import React from "react"
import PropTypes from "prop-types"
import { MDXProvider } from "@mdx-js/react"

import Header from "./header"
import Footer from "./footer"
import { ButtonPurple } from "./button"
import MembersFee from "./membersFee"
import Program from "./program"
import "./layout.css"

const Layout = ({ children }) => (
  <div className="container">
    <Header />
    <main className="article">
      <MDXProvider
        components={{
          MembersFee: MembersFee,
          ButtonPurple: ButtonPurple,
          Program: Program,
        }}
      >
        {children}
      </MDXProvider>
    </main>
    <Footer />
  </div>
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
